export default __webpack_public_path__ + "e418bf257af1052628d8c981d158674c.woff2";